export default {
  data: function () {
    return {
      sliderHero: null
    };
  },
  methods: {
    showToolbar: function () {
      var self = this;
      setTimeout(function () {
        self.$('.toolbar').removeClass('toolbar-hidden');
      });
    },
    initializeSliderHero: function () {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      self.sliderHero = app.swiper.create('.slider-hero .swiper-container', {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        centeredSlides: true,
        effect: 'coverflow',
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true
        },
        grabCursor: true,
        loop: true,
        slidesPerView: 'auto'
      });
    }
  },
  on: {
    pageInit: function () {
      console.log('pageInit');
      var self = this;
      self.showToolbar();
      self.initializeSliderHero();
    }
  },
  id: 'e7741217a3',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page" data-name="home">\n    <!-- Top Navbar -->\n    <div class="navbar navbar-large">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner">\n        <div class="left">\n          <a href="#" class="link icon-only panel-open" data-panel="left">\n            <i class="icon f7-icons if-not-md">menu</i>\n            <i class="icon material-icons if-md">menu</i>\n          </a>\n        </div>\n        <div class="title sliding">Law of Life</div>\n        <!-- <div class="right">\n          <a href="#" class="link icon-only panel-open" data-panel="right">\n            <i class="icon f7-icons if-not-md">menu</i>\n            <i class="icon material-icons if-md">menu</i>\n          </a>\n        </div> -->\n        <div class="title-large">\n          <div class="title-large-text">Law of Life</div>\n        </div>\n      </div>\n    </div>\n    <!-- Toolbar-->\n    <!-- <div class="toolbar toolbar-bottom">\n      <div class="toolbar-inner">\n        <a href="#" class="link">Left Link</a>\n        <a href="#" class="link">Right Link</a>\n      </div>\n    </div> -->\n    <!-- Scrollable page content-->\n    <div class="page-content">\n		<div class="slider-hero">\n			<div class="swiper-container swiper-init">\n				<div class="swiper-wrapper">\n\n					<div class="swiper-slide">\n						<div class="slide-content" style="background-image: linear-gradient(-20deg, #667EEA 0%, #764BA2 100%);">\n							<div class="slide-media">\n								<i class="fa-stack fa-2x">\n									<span class="fas fa-circle fa-stack-2x text-color-white"></span>\n									<span class="fas fa-hand-holding-heart fa-stack-1x" style="color: #764BA2;"></span>\n								</i>\n							</div>\n							<div class="slide-title">The Law of Life</div>\n							<div class="slide-text">Take to give.</div>\n						</div>\n					</div>\n\n					<!-- <div class="swiper-slide">\n						<div class="slide-content" style="background-image: linear-gradient(-20deg, #F77062 0%, #FE5196 100%);">\n							<div class="slide-title">Who needs to be treated?</div>\n							<div class="embed-responsive embed-responsive-16by9">\n								<iframe class="embed-responsive-item" src="https://www.youtube-nocookie.com/embed/GVeO44mS5d0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>\n							</div>\n						</div>\n					</div> -->\n\n					<div class="swiper-slide">\n						<div class="slide-content" style="background-image: linear-gradient(-20deg, #F77062 0%, #FE5196 100%);">\n							<div class="slide-media">\n								<i class="fa-stack fa-2x">\n									<span class="fas fa-circle fa-stack-2x text-color-white"></span>\n									<span class="fas fa-brain fa-stack-1x" style="color: #F77062;"></span>\n								</i>\n							</div>\n							<div class="slide-title">Principles for health and happiness</div>\n							<div class="slide-text">Based on unchangeable laws - not on opinions.</div>\n						</div>\n					</div>\n\n					<div class="swiper-slide">\n						<div class="slide-content" style="background-image: linear-gradient(-20deg, #FC6076 0%, #FF9A44 100%);">\n							<div class="slide-media">\n								<i class="fa-stack fa-2x">\n									<span class="fas fa-circle fa-stack-2x text-color-white"></span>\n									<span class="fas fa-pencil-ruler fa-stack-1x" style="color: #FF9A44;"></span>\n								</i>\n							</div>\n							<div class="slide-title">Fundamental knowledge</div>\n							<div class="slide-text">Everyone needs to know this. With whom can you share it today?</div>\n						</div>\n					</div>\n\n					<div class="swiper-slide">\n						<div class="slide-content" style="background-image: linear-gradient(-20deg, #2AF598 0%, #009EFD 100%);">\n							<div class="slide-media">\n								<i class="fa-stack fa-2x">\n									<span class="fas fa-circle fa-stack-2x text-color-white"></span>\n									<span class="fas fa-book fa-stack-1x" style="color: #2AF598;"></span>\n								</i>\n							</div>\n							<div class="slide-title">The greatest lesson book</div>\n							<div class="slide-text">Learn from nature!</div>\n						</div>\n					</div>\n\n					<div class="swiper-slide">\n						<div class="slide-content" style="background-image: linear-gradient(-20deg, #C471F5 0%, #FA71CD 100%);">\n							<div class="slide-media">\n								<i class="fa-stack fa-2x">\n									<span class="fas fa-circle fa-stack-2x text-color-white"></span>\n									<span class="fas fa-rocket fa-stack-1x" style="color: #FA71CD;"></span>\n								</i>\n							</div>\n							<div class="slide-title">Website</div>\n							<div class="slide-actions">\n								<a href="https://lawof.life" target="_blank" class="button button-fill color-white external" style="color: #FA71CD;">lawof.life</a>\n							</div>\n						</div>\n					</div>\n\n				</div>\n			</div>\n		</div>\n\n\n\n\n      <!-- <div class="block block-strong">\n        <p>Welcome to the Law of Life App!</p>\n        \n        <p>This is an example of split view application layout, commonly used on tablets. The main approach of such kind of layout is that you can see different views at the same time.</p>\n\n        <p>Each view may have different layout, different navbar type (dynamic, fixed or static) or without navbar.</p>\n\n        <p>The fun thing is that you can easily control one view from another without any line of JavaScript just using "data-view" attribute on links.</p>\n      </div>\n      <div class="block-title">Navigation</div>\n      <div class="list">\n        <ul>\n          <li>\n            <a href="/about/" class="item-content item-link">\n              <div class="item-inner">\n                <div class="item-title">About</div>\n              </div>\n            </a>\n          </li>\n          <li>\n            <a href="/form/" class="item-content item-link">\n              <div class="item-inner">\n                <div class="item-title">Form</div>\n              </div>\n            </a>\n          </li>\n        </ul>\n      </div>\n\n      <div class="block-title">Modals</div>\n      <div class="block block-strong">\n        <div class="row">\n          <div class="col-50">\n            <a href="#" class="button button-raised button-fill popup-open" data-popup="#my-popup">Popup</a>\n          </div>\n          <div class="col-50">\n            <a href="#" class="button button-raised button-fill login-screen-open" data-login-screen="#my-login-screen">Login Screen</a>\n          </div>\n        </div>\n      </div>\n\n      <div class="block-title">Panels</div>\n      <div class="block block-strong">\n        <div class="row">\n          <div class="col-50">\n            <a href="#" class="button button-raised button-fill panel-open" data-panel="left">Left Panel</a>\n          </div>\n          <div class="col-50">\n            <a href="#" class="button button-raised button-fill panel-open" data-panel="right">Right Panel</a>\n          </div>\n        </div>\n      </div>\n\n      <div class="list links-list">\n        <ul>\n          <li>\n            <a href="/dynamic-route/blog/45/post/125/?foo=bar#about">Dynamic (Component) Route</a>\n          </li>\n          <li>\n            <a href="/load-something-that-doesnt-exist/">Default Route (404)</a>\n          </li>\n          <li>\n            <a href="/request-and-load/user/123456/">Request Data & Load</a>\n          </li>\n        </ul>\n      </div> -->\n    </div>\n  </div>\n';
      return r;
    }(this);
  },

  style: `
[data-f7-e7741217a3] .slider-hero .swiper-container {
		height: 352px;
		height: 50vh;
	}

[data-f7-e7741217a3] .slider-hero .swiper-slide {
		box-sizing: border-box;
		padding: 16px;
	}

[data-f7-e7741217a3] .slider-hero .slide-content {
		align-items: center;
		border-radius: 16px;
		box-sizing: border-box;
		color: #FFFFFF;
		display: flex;
		flex-direction: column;
		height: 100%;
		justify-content: center;
		padding: 16px;
		text-align: center;
		width: 100%;
	}

[data-f7-e7741217a3] .slider-hero .slide-media {
		height: 56px;
	}

[data-f7-e7741217a3] .slider-hero .slide-title {
		font-size: 22px;
		margin-top: 8px;
	}

[data-f7-e7741217a3] .slider-hero .slide-text {
		font-size: 15px;
		margin-top: 8px;
	}

[data-f7-e7741217a3] .slider-hero .slide-actions {
		margin-top: 16px;
	}

[data-f7-e7741217a3] .swiper-container-3d .swiper-slide-shadow-left {
		background-image: none;
	}

[data-f7-e7741217a3] .swiper-container-3d .swiper-slide-shadow-right {
		background-image: none;
	}
`,
  styleScoped: true
};